import React, { useState, useEffect, useRef, useContext } from 'react';

import { Button } from 'web-store-modules/packages/web-store-ui-library';
import FlyUpModal from '../FlyUpModal';
import { getFontStylesAsync } from '../../../../utils/StoreConfigManager';
import './TextModal.css';
import { isMobileDevice } from 'web-store-modules/packages/obsess-device-detector';
import { constructUrl } from '../../../../utils/UrlConstructor';
import { AppContext } from "../../../../AppContext.jsx";
import { ImageHotspotCTAClicked, TextPopUpButtonClicked } from "../../../../utils/Analytics";
import ModalOverlay from '../ModalOverlay';
import ReactHtmlParser from "react-html-parser";
import { getTrackingParameter } from '../../../../utils/StoreConfigManager';
import { withTranslation } from 'react-i18next';

const isMobile = isMobileDevice();

const localeRedirectCTA = {
    '6176e05a9b2c20ab916036d5': {
        'us_en': 'https://www.ferragamo.com/shop/us/en/shoes-1/sneakers-2',
        'jpn_ja': 'https://www.ferragamo.com/shop/jpn/ja/men-shoes/スニーカー--10',
        'esp_es': 'https://www.ferragamo.com/shop/esp/es/zapatos-hombre/sneakers-',
        'fra_fr': 'https://www.ferragamo.com/shop/fra/fr/chaussures-homme/baskets-',
        'ita_it': 'https://www.ferragamo.com/shop/ita/it/scarpe-uomo/sneakers-uomo',
        'mex_es': 'https://www.ferragamo.com/shop/mex/es/zapatos-3074457345616743926--5/sneakers-3074457345616744093--5',
        'eu_en': 'https://www.ferragamo.com/shop/eu/en/man-shoes/sneakers-',
        'eu_de': 'https://www.ferragamo.com/shop/eu/de/schuhe-herren/sneakers-herren',
        'gb_en': 'https://www.ferragamo.com/shop/gb/en/shoes-men/sneakers-m',
        'aus_en': 'https://www.ferragamo.com/shop/aus/en/men-shoes/mens-sneakers',
        'ca_en': 'https://www.ferragamo.com/shop/ca/en/shoes-3074457345616743845--1/sneakers-3074457345616744011--1',
        'kor_kr': 'https://www.ferragamo.com/shop/kor/ko/슈즈--9/스니커즈-9'
    },
    '618c1994b7a38161eb396cec': {
        'us_en': 'https://www.ferragamo.com/shop/us/en/men/wallets-small-leather-goods',
        'jpn_ja': 'https://www.ferragamo.com/shop/jpn/ja/men-10/man-wallets-small-leathers-goods',
        'esp_es': 'https://www.ferragamo.com/shop/esp/es/hombre/marroquinería-',
        'fra_fr': 'https://www.ferragamo.com/shop/fra/fr/hommes/petite-maroquinerie-',
        'ita_it': 'https://www.ferragamo.com/shop/ita/it/uomo/piccola-pelletteria-uomo',
        'mex_es': 'https://www.ferragamo.com/shop/mex/es/hombre/accesorios-piel-3074457345616743928--5',
        'eu_en': 'https://www.ferragamo.com/shop/eu/en/men/man-wallets-small-leather-goods',
        'eu_de': 'https://www.ferragamo.com/shop/eu/de/herren/kleinlederwaren-herren',
        'gb_en': 'https://www.ferragamo.com/shop/gb/en/men/wallets-small-leather-goods-men',
        'aus_en': 'https://www.ferragamo.com/shop/aus/en/men/men-wallets-small-leather-goods',
        'ca_en': 'https://www.ferragamo.com/shop/ca/en/men/wallets---small-leather-goods',
        'kor_kr': 'https://www.ferragamo.com/shop/kor/ko/men/지갑-및-가죽-소품-9'
    },
    '618bfccf7acd45ffe0a5dce7': {
        'us_en': 'https://www.ferragamo.com/shop/us/en/women/silk-bijoux',
        'jpn_ja': 'https://www.ferragamo.com/shop/jpn/ja/women--10/スカーフ-アクセサリー',
        'esp_es': 'https://www.ferragamo.com/shop/esp/es/mujer/accesorios-seda',
        'fra_fr': 'https://www.ferragamo.com/shop/fra/fr/femmes/Accessoires',
        'ita_it': 'https://www.ferragamo.com/shop/ita/it/donna/accessori-in-seta-donna',
        'mex_es': 'https://www.ferragamo.com/shop/mex/es/mujer/mascada',
        'eu_en': 'https://www.ferragamo.com/shop/eu/de/damen/accessoires',
        'eu_de': 'https://www.ferragamo.com/shop/eu/en/women/accessories',
        'gb_en': 'https://www.ferragamo.com/shop/gb/en/women/silk-and-accessories',
        'aus_en': 'https://www.ferragamo.com/shop/aus/en/women/women-accessories',
        'ca_en': 'https://www.ferragamo.com/shop/ca/en/women/scarves',
        'kor_kr': 'https://www.ferragamo.com/shop/kor/ko/women-9/스카프-및-액세서리'
    },
    '6176d78f9b2c20ab9160300b': {
        'us_en': 'https://www.ferragamo.com/viva-shoes',
        'jpn_ja': 'https://www.ferragamo.com/viva-shoes',
        'esp_es': 'https://www.ferragamo.com/viva-shoes',
        'fra_fr': 'https://www.ferragamo.com/viva-shoes',
        'ita_it': 'https://www.ferragamo.com/viva-shoes',
        'mex_es': 'https://www.ferragamo.com/viva-shoes',
        'eu_en': 'https://www.ferragamo.com/viva-shoes',
        'eu_de': 'https://www.ferragamo.com/viva-shoes',
        'gb_en': 'https://www.ferragamo.com/viva-shoes',
        'aus_en': 'https://www.ferragamo.com/viva-shoes',
        'ca_en': 'https://www.ferragamo.com/viva-shoes',
        'kor_kr': 'https://www.ferragamo.com/viva-shoes'
    },
    '61853805a25ecf11ccac5cd1': {
        'us_en': 'https://www.ferragamo.com/shop/us/en/shoes/boots-1',
        'jpn_ja': 'https://www.ferragamo.com/shop/jpn/ja/シューズ/boots',
        'esp_es': 'https://www.ferragamo.com/shop/esp/es/zapatos/botines-y-botas',
        'fra_fr': 'https://www.ferragamo.com/shop/fra/fr/chaussures/bottes',
        'ita_it': 'https://www.ferragamo.com/shop/ita/it/scarpe/stivaletti-stivali',
        'mex_es': 'https://www.ferragamo.com/shop/mex/es/zapatos/botines-y-botas',
        'eu_en': 'https://www.ferragamo.com/shop/eu/en/shoes/boots',
        'eu_de': 'https://www.ferragamo.com/shop/eu/de/schuhe/stiefel',
        'gb_en': 'https://www.ferragamo.com/shop/gb/en/shoes/boot-bootie',
        'aus_en': 'https://www.ferragamo.com/shop/aus/en/women-shoes/au-boots',
        'ca_en': 'https://www.ferragamo.com/shop/ca/en/women/shoes/w-sale-bootsandbooties-ca',
        'kor_kr': 'https://www.ferragamo.com/shop/kor/ko/슈즈-9/boots-9'
    },
    /* '6176daca9b2c20ab91603012': {
        'us_en': '',
        'jpn_ja': '',
        'esp_es': '',
        'fra_fr': '',
        'ita_it': '',
        'mex_es': '',
        'eu_en': '',
        'eu_de': '',
        'gb_en': '',
        'aus_en': '',
        'ca_en': '',
    }, */
    '6176daca9b2c20ab91603012': {
        'us_en': 'https://www.ferragamo.com/shop/us/en/wallets-small-leather-goods/belts-man',
        'jpn_ja': 'https://www.ferragamo.com/shop/jpn/ja/men-10/man-belts',
        'esp_es': 'https://www.ferragamo.com/shop/esp/es/hombre/cinturones-',
        'fra_fr': 'https://www.ferragamo.com/shop/fra/fr/hommes/ceintures-',
        'ita_it': 'https://www.ferragamo.com/shop/ita/it/uomo/cinture-uomo-it',
        'mex_es': 'https://www.ferragamo.com/shop/mex/es/hombre/mx-cinturones',
        'eu_en': 'https://www.ferragamo.com/shop/eu/en/men/man-belts',
        'eu_de': 'https://www.ferragamo.com/shop/eu/de/herren/guertel-herren',
        'gb_en': 'https://www.ferragamo.com/shop/gb/en/men/belts-m',
        'aus_en': 'https://www.ferragamo.com/shop/aus/en/men/men-belts',
        'ca_en': 'https://www.ferragamo.com/shop/ca/en/wallets---small-leather-goods/belts-man-ca',
        'kor_kr': 'https://www.ferragamo.com/shop/kor/ko/men/%EB%B2%A8%ED%8A%B8---9'
    },
    '6176ddd2da91633089b266e5': {
        'us_en': 'https://www.ferragamo.com/shop/us/en/shoes-1/lace-ups-1',
        'jpn_ja': 'https://www.ferragamo.com/shop/jpn/ja/men-shoes/レースアップ--10',
        'esp_es': 'https://www.ferragamo.com/shop/esp/es/zapatos-hombre/zapatos-con-cordones',
        'fra_fr': 'https://www.ferragamo.com/shop/fra/fr/chaussures-homme/lacets',
        'ita_it': 'https://www.ferragamo.com/shop/ita/it/scarpe-uomo/stringate',
        'mex_es': 'https://www.ferragamo.com/shop/mex/es/zapatos-3074457345616743926--5/zapatos-con-cordones',
        'eu_en': 'https://www.ferragamo.com/shop/eu/en/man-shoes/lace-ups',
        'eu_de': 'https://www.ferragamo.com/shop/eu/de/schuhe-herren/schnürschuhe',
        'gb_en': 'https://www.ferragamo.com/shop/gb/en/shoes-men/lace-ups-m',
        'aus_en': 'https://www.ferragamo.com/shop/aus/en/men-shoes/men-lace-ups',
        'ca_en': 'https://www.ferragamo.com/shop/ca/en/shoes-3074457345616743845--1/lace-ups',
        'kor_kr': 'https://www.ferragamo.com/shop/kor/ko/슈즈--9/레이스업-9'
    },
    '6185445bf86d757e1c44cdc6': {
        'us_en': 'https://www.ferragamo.com/shop/us/en/shoes/pumps',
        'jpn_ja': 'https://www.ferragamo.com/shop/jpn/ja/シューズ/パンプス--10',
        'esp_es': 'https://www.ferragamo.com/shop/esp/es/zapatos/zapatos-de-salón',
        'fra_fr': 'https://www.ferragamo.com/shop/fra/fr/chaussures/décolletés',
        'ita_it': 'https://www.ferragamo.com/shop/ita/it/scarpe/décolleté-',
        'mex_es': 'https://www.ferragamo.com/shop/mex/es/zapatos/zapatos-de-salón',
        'eu_en': 'https://www.ferragamo.com/shop/eu/en/shoes/pumps-24',
        'eu_de': 'https://www.ferragamo.com/shop/eu/de/schuhe/pumps',
        'gb_en': 'https://www.ferragamo.com/shop/gb/en/shoes/pumps-',
        'aus_en': 'https://www.ferragamo.com/shop/aus/en/women-shoes/women-pumps',
        'ca_en': 'https://www.ferragamo.com/shop/ca/en/women/shoes/ca-pumps',
        'kor_kr': 'https://www.ferragamo.com/shop/kor/ko/슈즈-9/펌프스-9'
    },
    '618c3aebe61530a6afa9a637': {
        'us_en': 'https://www.ferragamo.com/shop/us/en/sf/us-studio-bag',
        'jpn_ja': 'https://www.ferragamo.com/shop/jpn/ja/sf/jp-studio-bag',
        'esp_es': 'https://www.ferragamo.com/shop/esp/es/sf/es-studio-bag',
        'fra_fr': 'https://www.ferragamo.com/shop/fra/fr/sf/fr-studio-bag',
        'ita_it': 'https://www.ferragamo.com/shop/ita/it/sf/it-studio-bag',
        'mex_es': 'https://www.ferragamo.com/shop/mex/es/sf/mx-studio-bag',
        'eu_en': 'https://www.ferragamo.com/shop/eu/en/sf/oe-studio-bag-en',
        'eu_de': 'https://www.ferragamo.com/shop/eu/de/sf/oe-studio-bag-en',
        'gb_en': 'https://www.ferragamo.com/shop/gb/en/sf/uk-the-studio',
        'aus_en': 'https://www.ferragamo.com/shop/aus/en/sf/au-the-studio',
        'ca_en': 'https://www.ferragamo.com/shop/ca/en/sf/ca-studio-bag',
        'kor_kr': 'https://www.ferragamo.com/shop/kor/ko/sf/kr-studio-bag'
    },
    '618bff927acd45ffe0a5dd4d': {
        'us_en': 'https://www.ferragamo.com/shop/us/en/shoes/sandals-espadrilles',
        'jpn_ja': 'https://www.ferragamo.com/shop/jpn/ja/シューズ/jp-sandals-espadrilles',
        'esp_es': 'https://www.ferragamo.com/shop/esp/es/zapatos/sandalias-alpargatas-es',
        'fra_fr': 'https://www.ferragamo.com/shop/fra/fr/chaussures/sandales-et-espadrilles',
        'ita_it': 'https://www.ferragamo.com/shop/ita/it/scarpe/sandali-espadrillas',
        'mex_es': 'https://www.ferragamo.com/shop/mex/es/zapatos/sandalias-alpargatas',
        'eu_en': 'https://www.ferragamo.com/shop/eu/en/shoes/oe-sandals-espadrilles',
        'eu_de': 'https://www.ferragamo.com/shop/eu/de/schuhe/sandalen-espadrilles',
        'gb_en': 'https://www.ferragamo.com/shop/gb/en/shoes/sandals-espadrilles-uk',
        'aus_en': 'https://www.ferragamo.com/shop/aus/en/women-shoes/women-sandals-espadrilles',
        'ca_en': 'https://www.ferragamo.com/shop/ca/en/women/shoes/ca-sandals-espadrilles',
        'kor_kr': 'https://www.ferragamo.com/shop/kor/ko/슈즈-9/샌들-9'
    },
    '61942a9ef981e9b40582e43e': {
        'us_en': 'https://www.ferragamo.com/shop/us/en/sf/holiday-it-s-movie-o-clock',
        'jpn_ja': 'https://www.ferragamo.com/shop/jpn/ja/sf/holiday-it-s-movie-o-clock',
        'esp_es': 'https://www.ferragamo.com/shop/esp/es/sf/holiday-it-s-movie-o-clock',
        'fra_fr': 'https://www.ferragamo.com/shop/fra/fr/sf/holiday-it-s-movie-o-clock',
        'ita_it': 'https://www.ferragamo.com/shop/ita/it/sf/holiday-it-s-movie-o-clock',
        'mex_es': 'https://www.ferragamo.com/shop/mex/es/sf/holiday-it-s-movie-o-clock',
        'eu_en': 'https://www.ferragamo.com/shop/eu/en/sf/holiday-it-s-movie-o-clock',
        'eu_de': 'https://www.ferragamo.com/shop/eu/de/sf/holiday-it-s-movie-o-clock',
        'gb_en': 'https://www.ferragamo.com/shop/gb/en/sf/holiday-it-s-movie-o-clock',
        'aus_en': 'https://www.ferragamo.com/shop/aus/en/sf/holiday-it-s-movie-o-clock',
        'ca_en': 'https://www.ferragamo.com/shop/ca/en/sf/holiday-it-s-movie-o-clock',
        'kor_kr': 'https://www.ferragamo.com/shop/kor/ko/sf/holiday-it-s-movie-o-clock'
    },
    '61942a9ef981e9b40582e43d': {
        'us_en': 'https://www.ferragamo.com/shop/us/en/sf/holiday-it-s-movie-o-clock',
        'jpn_ja': 'https://www.ferragamo.com/shop/jpn/ja/sf/holiday-it-s-movie-o-clock',
        'esp_es': 'https://www.ferragamo.com/shop/esp/es/sf/holiday-it-s-movie-o-clock',
        'fra_fr': 'https://www.ferragamo.com/shop/fra/fr/sf/holiday-it-s-movie-o-clock',
        'ita_it': 'https://www.ferragamo.com/shop/ita/it/sf/holiday-it-s-movie-o-clock',
        'mex_es': 'https://www.ferragamo.com/shop/mex/es/sf/holiday-it-s-movie-o-clock',
        'eu_en': 'https://www.ferragamo.com/shop/eu/en/sf/holiday-it-s-movie-o-clock',
        'eu_de': 'https://www.ferragamo.com/shop/eu/de/sf/holiday-it-s-movie-o-clock',
        'gb_en': 'https://www.ferragamo.com/shop/gb/en/sf/holiday-it-s-movie-o-clock',
        'aus_en': 'https://www.ferragamo.com/shop/aus/en/sf/holiday-it-s-movie-o-clock',
        'ca_en': 'https://www.ferragamo.com/shop/ca/en/sf/holiday-it-s-movie-o-clock',
        'kor_kr': 'https://www.ferragamo.com/shop/kor/ko/sf/holiday-it-s-movie-o-clock'
    },
    '6185485d5cd7cb821b9ae334': {
        'us_en': 'https://www.ferragamo.com/shop/us/en/shoes/pumps',
        'jpn_ja': 'https://www.ferragamo.com/shop/jpn/ja/シューズ/パンプス--10',
        'esp_es': 'https://www.ferragamo.com/shop/esp/es/zapatos/zapatos-de-salón',
        'fra_fr': 'https://www.ferragamo.com/shop/fra/fr/chaussures/décolletés',
        'ita_it': 'https://www.ferragamo.com/shop/ita/it/scarpe/décolleté-',
        'mex_es': 'https://www.ferragamo.com/shop/mex/es/zapatos/zapatos-de-salón',
        'eu_en': 'https://www.ferragamo.com/shop/eu/en/shoes/pumps-24',
        'eu_de': 'https://www.ferragamo.com/shop/eu/de/schuhe/pumps',
        'gb_en': 'https://www.ferragamo.com/shop/gb/en/shoes/pumps-',
        'aus_en': 'https://www.ferragamo.com/shop/aus/en/women-shoes/women-pumps',
        'ca_en': 'https://www.ferragamo.com/shop/ca/en/women/shoes/ca-pumps',
        'kor_kr': 'https://www.ferragamo.com/shop/kor/ko/슈즈-9/펌프스-9'
    },
    '6185499ea25ecf11ccac5f98': {
        'us_en': 'https://www.ferragamo.com/shop/us/en/sf/us-studio-bag',
        'jpn_ja': 'https://www.ferragamo.com/shop/jpn/ja/sf/jp-studio-bag',
        'esp_es': 'https://www.ferragamo.com/shop/esp/es/sf/es-studio-bag',
        'fra_fr': 'https://www.ferragamo.com/shop/fra/fr/sf/fr-studio-bag',
        'ita_it': 'https://www.ferragamo.com/shop/ita/it/sf/it-studio-bag',
        'mex_es': 'https://www.ferragamo.com/shop/mex/es/sf/mx-studio-bag',
        'eu_en': 'https://www.ferragamo.com/shop/eu/en/sf/oe-studio-bag-en',
        'eu_de': 'https://www.ferragamo.com/shop/eu/de/sf/oe-studio-bag-en',
        'gb_en': 'https://www.ferragamo.com/shop/gb/en/sf/uk-the-studio',
        'aus_en': 'https://www.ferragamo.com/shop/aus/en/sf/au-the-studio',
        'ca_en': 'https://www.ferragamo.com/shop/ca/en/sf/ca-studio-bag',
        'kor_kr': 'https://www.ferragamo.com/shop/kor/ko/sf/kr-studio-bag'
    },
    '6177422281bd4cfac427bd1f': {
        'us_en': 'https://www.ferragamo.com/shop/us/en/shoes-1/lace-ups-1',
        'jpn_ja': 'https://www.ferragamo.com/shop/jpn/ja/men-shoes/レースアップ--10',
        'esp_es': 'https://www.ferragamo.com/shop/esp/es/zapatos-hombre/zapatos-con-cordones',
        'fra_fr': 'https://www.ferragamo.com/shop/fra/fr/chaussures-homme/lacets',
        'ita_it': 'https://www.ferragamo.com/shop/ita/it/scarpe-uomo/stringate',
        'mex_es': 'https://www.ferragamo.com/shop/mex/es/zapatos-3074457345616743926--5/zapatos-con-cordones',
        'eu_en': 'https://www.ferragamo.com/shop/eu/en/man-shoes/lace-ups',
        'eu_de': 'https://www.ferragamo.com/shop/eu/de/schuhe-herren/schnürschuhe',
        'gb_en': 'https://www.ferragamo.com/shop/gb/en/shoes-men/lace-ups-m',
        'aus_en': 'https://www.ferragamo.com/shop/aus/en/men-shoes/men-lace-ups',
        'ca_en': 'https://www.ferragamo.com/shop/ca/en/shoes-3074457345616743845--1/lace-ups',
        'kor_kr': 'https://www.ferragamo.com/shop/kor/ko/슈즈--9/레이스업-9'
    }
}

const TextModal = ({ modalContent, onModalHidden, onClose, primaryColor, secondaryColor, hotspotId, roomId, t, i18n }) => {
    const { title, sub_title, body, button_copy, button_url, url } = modalContent;
    const [fontStyles, setFontStyles] = useState();
    const [modalActive, setModalActive] = useState();
    const modalRef = useRef();
    const { currentSceneName } = useContext(AppContext);
    useEffect(() => {
        fetchFontStyles();
        addListeners();
        return (() => {
            removeListeners();
        });

    }, []);

    const addListeners = () => {
        if (isMobile) {
            window.addEventListener('touchend', handleModalClose);
        } else {
            window.addEventListener('click', handleModalClose);
        }
    }

    const removeListeners = () => {
        if (isMobile) {
            window.removeEventListener('touchend', handleModalClose);
        } else {
            window.removeEventListener('click', handleModalClose);
        }
    }

    const fetchFontStyles = () => {
        getFontStylesAsync()
            .then((fontStyles) => setFontStyles(fontStyles))
            .catch((err) => console.error(err));

    }

    const handleModalClose = (e) => {
        if (modalRef && modalRef.current.contains(e.target)) {
            return;
        }
        closeModal();
    }

    const closeModal = () => {
        if (onClose) {
            setModalActive(false);
            onClose();
        }
    }

    const handleClick = () => {
        TextPopUpButtonClicked(currentSceneName);
        ImageHotspotCTAClicked(title);
        let attRedirectPath = constructUrl(button_url);
        let trackingParam = getTrackingParameter();
        if (localeRedirectCTA[hotspotId]) {
            if (localeRedirectCTA[hotspotId][i18n.language]) {
                attRedirectPath = localeRedirectCTA[hotspotId][i18n.language]
            }
        }
        trackingParam = `utm_source=houseofgift&utm_medium=${i18n.language}&utm_campaign=holiday21&utm_content=${title}_${currentSceneName}`

        const trackingParamUrl = `${attRedirectPath}?${trackingParam}`
        window.open(trackingParamUrl, '_blank');
    }

    const productButton = () => {
        return (
            <div className="product-button-container"><Button
                hoverStyleChange={true}
                onClick={handleClick}
                primaryColor={primaryColor}
                secondaryColor={secondaryColor}
                className="text-marker-button flex-center obsessvr-regularFont pointer product-button"
                style={{ padding: '0', margin: '0 1%' }}
                primaryBorderColor='white'
                secondaryBorderColor='white'
                primaryBorderWidth='0px'
                secondaryBorderWidth='0px'
                insetBorder={true}
                padded={false}
            >
                <p className='obsessvr-regularFont' style={{ fontFamily: 'MessinaSans-Semibold', textTransform: 'uppercase', whiteSpace: 'nowrap', fontSize: '12px' }}>
                    {t('textModalCTA')}
                </p>
            </Button></div>
        )
    }

    const textContainer = () => {
        return (
            body ? <div className='text-modal-text-container'>
                <pre
                    style={{
                        fontSize: isMobile ? '15px' : '18px',
                        fontFamily: fontStyles.popUpText.name,
                        whiteSpace: 'pre-wrap',
                    }}
                >
                    {ReactHtmlParser(body)}
                </pre>
            </div> : ''
        )
    }

    const titleRender = () => {
        return (
            title ? <div className='text-modal-title-container' style={{ paddingBottom: '21px' }}>
                <span
                    style={{
                        fontSize: '18px',
                        fontFamily: fontStyles.popUpTitle.name
                    }}>
                    {title}
                </span>
            </div> : ''
        );
    }

    const subtitleRender = () => {
        return (
            sub_title ? <div className='text-modal-subtitle-container'>
                <span
                    style={{
                        fontSize: '21px',
                        fontFamily: fontStyles.popUpSubtitle.name
                    }}>
                    {sub_title}
                </span>
            </div> : ''
        );
    }

    const imageRender = () => {
        const imageUrl = constructUrl(url);
        const roomHotspotId = roomId + "-" + hotspotId;
        var imgStyle;
        if (roomHotspotId == '614a6a668135ae99e7eb653e-614b35f6e831cdddf9c57238')
            imgStyle = { maxWidth: '100%', maxHeight: '350px' };
        else
            imgStyle = { maxWidth: '100%' }
        return (
            <div className="zoomedImageWrapper">
                <div className="zoomedImageContainer flex-centerR">
                    {/* <img src={imageUrl} style={imgStyle} /> */}
                    <img src={(hotspotId === '618e950a940fe5986734e67b') ? imageRenderPiano() : imageUrl} style={imgStyle} />
                </div>
            </div>

        );
    }
    const imageRenderPiano = () => {
        let imgScr = 'https://cdn.obsess-vr.com/ferragamo/locale/ENG.jpg'
        switch (i18n.language) {
            case 'us_en':
            case 'gb_en':
            case 'aus_en':
            case 'ca_en':
            case 'eu_en':
                imgScr = 'https://cdn.obsess-vr.com/ferragamo/locale/ENG.jpg'
                break;
            case 'eu_de':
                imgScr = 'https://cdn.obsess-vr.com/ferragamo/locale/DE.jpg'
                break;
            case 'jpn_ja':
                imgScr = 'https://cdn.obsess-vr.com/ferragamo/locale/JP.jpg'
                break;
            case 'kor_kr':
                imgScr = 'https://cdn.obsess-vr.com/ferragamo/locale/KR.jpg'
                break;
            case 'esp_es':
                imgScr = 'https://cdn.obsess-vr.com/ferragamo/locale/ES.jpg'
                break;
            case 'fra_fr':
                imgScr = 'https://cdn.obsess-vr.com/ferragamo/locale/FR.jpg'
                break;
            case 'ita_it':
                imgScr = 'https://cdn.obsess-vr.com/ferragamo/locale/IT.jpg'
                break;
            case 'mex_es':
                imgScr = 'https://cdn.obsess-vr.com/ferragamo/locale/MX.jpg'
                break;
            default:
                imgScr = 'https://cdn.obsess-vr.com/ferragamo/locale/ENG.jpg'
        }
        return imgScr;
    }

    const renderModalContent = () => {
        return (
            <div className='text-modal-content' style={{ textAlign: 'center' }} ref={modalRef}>
                {titleRender()}
                {subtitleRender()}
                {url && imageRender()}
                {/* {hotspotId === '618e950a940fe5986734e67b' && imageRenderPiano()}            */}
                {textContainer()}
                {button_copy && productButton()}
            </div>
        )
    }
    return (
        //Added the isImage Loaded bool here to display the close button on the Modal due to a condition in Modal.jsx
        <FlyUpModal extraClassName={`text-modal-container ${url ? "" : "text-only"} ${hotspotId === '6196eafc069ba3d99800346a' ? 'text-modal-container-resize' : ''}`} onModalHidden={onModalHidden} isOpaque
            textPopup hideCloseIcon isImageLoaded>
            <ModalOverlay />
            {!!fontStyles && renderModalContent()}
        </FlyUpModal>
    );
}

export default withTranslation()(TextModal);


